<template>
<div>
    <div class="meeting-header">
<!--      <p class="text-center"><img style="margin:0 auto" :src="state.meetingData.event.image" alt="" class="img-responsive"></p>-->
        <h2>{{state.meetingData.event.title}}</h2>
        <p>{{state.meetingData.event.where}}</p>
    </div>
</div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    name: 'Header',
    computed: {
      ...mapGetters({
        state: 'getState',
      }),
    },
  }
</script>

<style scoped>
.meeting-header {
  position: relative;
  overflow: hidden;
  margin-bottom: 24px;
  padding: 26px;

  background:
      radial-gradient(
          circle at top right,
          rgba(255, 255, 255, 0.15),
          transparent 45%
      ),
      linear-gradient(
          115deg,
          #148f94 0%,
          #427f9e 50%,
          #656dac 100%
      );

  border: 1px solid #487f9c;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(49, 75, 111, 0.18);

  color: #ffffff;
  font-family: inherit;
  text-align: center;
}

.meeting-header,
.meeting-header * {
  box-sizing: border-box;
}

/* Banner frame */
.meeting-header > p.text-center {
  margin: 0 0 26px;
  padding: 8px;

  background: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.65);
  border-radius: 12px;
  box-shadow: 0 6px 20px rgba(27, 51, 80, 0.18);
}

.meeting-header .img-responsive {
  display: block;
  width: 100%;
  max-width: 100%;
  height: auto;
  border-radius: 6px;
}

/* Event title */
.meeting-header > h2 {
  max-width: 900px;
  margin: 0 auto 18px;
  padding: 0;

  color: #ffffff;
  font-family: inherit;
  font-size: clamp(23px, 3vw, 34px);
  font-weight: 800;
  line-height: 1.3;
  letter-spacing: 0.035em;
  text-transform: uppercase;
  overflow-wrap: anywhere;
}

/* Location */
.meeting-header > p:last-child {
  display: table;
  max-width: 100%;
  margin: 0 auto;
  padding: 12px 22px;

  background: rgba(20, 42, 74, 0.28);
  border: 1px solid rgba(255, 255, 255, 0.32);
  border-radius: 10px;

  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  letter-spacing: 0.02em;
  overflow-wrap: anywhere;
}

/* Mobile adjustments */
@media (max-width: 600px) {
  .meeting-header {
    margin-bottom: 18px;
    padding: 14px;
    border-radius: 14px;
  }

  .meeting-header > p.text-center {
    margin-bottom: 20px;
    padding: 5px;
    border-radius: 9px;
  }

  .meeting-header .img-responsive {
    border-radius: 5px;
  }

  .meeting-header > h2 {
    margin-bottom: 16px;
    font-size: 23px;
    letter-spacing: 0.02em;
  }

  .meeting-header > p:last-child {
    padding: 10px 14px;
    font-size: 14px;
    border-radius: 8px;
  }
}
.meeting-header > h2 {
  font-weight: 300;
  letter-spacing: 0.025em;
}
</style>
